<template>
    <div id="content" class="cf site-content">
        <div id="primary" class="full-width-page">
            <main id="main" class="site-main" role="main">
                <article id="post-217" class="post-217 page type-page status-publish hentry">
                    <header class="entry-header"></header>
                    <!-- .entry-header -->
                    <div class="entry-content">
                        <div id="pl-217" class="panel-layout">
                            <div id="pg-217-0" class="panel-grid panel-no-style">
                                <div id="pgc-217-0-0" class="panel-grid-cell">
                                    <div id="panel-217-0-0-0" class="so-panel widget widget_black-studio-tinymce widget_black_studio_tinymce panel-first-child panel-last-child" data-index="0">
                                        <div class="textwidget">
                                            <p>
                                                <img class="aligncenter wp-image-824" :src="banner_pic" alt="" width="1000" height="370">
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div id="pg-217-1" class="panel-grid panel-no-style">
                                <div id="pgc-217-1-0" class="panel-grid-cell">
                                    <div id="panel-217-1-0-0" class="so-panel widget widget_black-studio-tinymce widget_black_studio_tinymce panel-first-child panel-last-child" data-index="1">
                                        <div class="textwidget" v-html="summary">
                                            <!-- <h2 style="text-align: center;"><span style="color: #089afc;">At KPKitchen</span>, we believe that the family is the most important thing in life and every mom loves to put a smile on her child’s face, even if it's with some small self-made pastries.</h2>
                                            <h2 style="text-align: center;">We serve busy moms who still take the time to bake for their children because there's nothing more satisfying for a mom to see her child’s face when taking the first bite of their homemade pastry and find out it does taste as good as it looks.</h2> -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="panel-grid panel-no-style">
                                <div id="pgc-217-2-0" class="panel-grid-cell">
                                    <div id="panel-217-2-0-0" class="so-panel widget widget_black-studio-tinymce widget_black_studio_tinymce panel-first-child panel-last-child" data-index="2">
                                        <div class="textwidget">
                                            <h2 style="text-align: center;">Our Products</h2>
                                            <hr>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="panel-grid panel-no-style" v-for="ss in items">
                                <div class="panel-grid-cell" v-for="item in ss">
                                    <div class="so-panel widget widget_black-studio-tinymce widget_black_studio_tinymce panel-first-child panel-last-child" data-index="3">
                                        <div class="textwidget">
                                            <p>
                                                <a :href="item.amazon_url" target="_blank" rel="noopener noreferrer">
                                                    <img class="aligncenter wp-image-138" :src="[$consts.serverPath + item.pic]" alt="Shop_01" width="248" height="auto">
                                                </a>
                                            </p>
                                            <h2 style="text-align: center;">{{item.title}}</h2>
                                            <h3 style="text-align: center;">On Sale! <span style="color: #999999;"><del>${{item.original_price}}</del></span> ${{item.price}}</h3>
                                            <h3 v-if="item.subtitle" class="a-size-large a-spacing-none" style="text-align: center;">
                                        <span id="productTitle" class="a-size-large">{{item.subtitle}}</span>
                                    </h3>
                                            <p>
                                                <a :href="item.amazon_url" target="_blank" rel="noopener">
                                                    <img class="aligncenter wp-image-857 size-medium" :src="amazon_buy_icon" width="300" height="auto">
                                                </a>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="pg-217-5" class="panel-grid panel-no-style">
                        <div id="pgc-217-5-0" class="panel-grid-cell">
                            <div id="panel-217-5-0-0" class="so-panel widget widget_black-studio-tinymce widget_black_studio_tinymce panel-first-child panel-last-child" data-index="7">
                                <div class="textwidget">
                                    <p><span class="" style="display:block;clear:both;height: 0px;padding-top: 5px;border-top-width:0px;border-bottom-width:0px;"></span>
                                    </p>
                                    <h2 style="text-align: center;">What Others Are Saying</h2>
                                    <hr>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="panel-grid panel-no-style">
                        <div id="pgc-217-6-0" class="panel-grid-cell">
                            <div id="panel-217-6-0-0" class="so-panel widget widget_black-studio-tinymce widget_black_studio_tinymce panel-first-child panel-last-child" data-index="8">
                                <div class="textwidget" v-html="left_comment">
                                </div>
                            </div>
                        </div>
                        <div class="panel-grid-cell">
                            <div class="so-panel widget widget_black-studio-tinymce widget_black_studio_tinymce panel-first-child panel-last-child" data-index="3">
                                <div class="textwidget" v-html="right_comment">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="pg-217-7" class="panel-grid panel-no-style">
                        <div id="pgc-217-7-0" class="panel-grid-cell">
                            <div id="panel-217-7-0-0" class="so-panel widget widget_black-studio-tinymce widget_black_studio_tinymce panel-first-child panel-last-child" data-index="10">
                                <div class="textwidget">
                                    <h3 style="text-align: center;">Follow us on:&nbsp;<br>
                                        <a v-if="facebookIcon" title="facebook" href="https://www.facebook.com" target="_blank">
                                            <img class="alignnone wp-image-395" :src="facebookIcon" width="25" height="25">
                                        </a>&nbsp; &nbsp; &nbsp;
                                        <a v-if="instagramIcon" title="instagram" href="https://www.instagram.com" target="_blank">
                                            <img class="alignnone wp-image-396" :src="instagramIcon" width="25" height="25">
                                        </a>&nbsp; &nbsp;&nbsp;&nbsp;
                                        <a v-if="twitterIcon" title="twitter" href="https://www.twitter.com" target="_blank">
                                            <img class="alignnone wp-image-393" :src="twitterIcon" width="25" height="25">
                                        </a>
                                    </h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </article>
                <!-- .entry-content -->
            </main>
            <!-- #main -->
        </div>
        <!-- #primary -->
        <PopupSubscribe></PopupSubscribe>
    </div>
</template>
<script type="text/javascript">
</script>
<!-- controls space -->
<style type="text/css" media="all" id="siteorigin-panels-layouts-head">
    /* Layout 217 */
    #pgc-217-0-0,
    #pgc-217-1-0,
    #pgc-217-2-0,
    #pgc-217-5-0,
    #pgc-217-7-0 {
        width: 100%;
        width: calc(100% - (0 * 30px))
    }
    #pl-217 #panel-217-0-0-0,
    #pl-217 #panel-217-1-0-0,
    #pl-217 #panel-217-2-0-0,
    #pl-217 #panel-217-3-0-0,
    #pl-217 #panel-217-3-1-0,
    #pl-217 #panel-217-4-0-0,
    #pl-217 #panel-217-4-1-0,
    #pl-217 #panel-217-5-0-0,
    #pl-217 #panel-217-6-0-0,
    #pl-217 #panel-217-6-1-0,
    #pl-217 #panel-217-7-0-0 {} #pg-217-0,
    #pg-217-1,
    #pg-217-2,
    #pg-217-3,
    #pg-217-4,
    #pg-217-5,
    #pg-217-6,
    #pl-217 .so-panel {
        margin-bottom: 30px
    }
    #pgc-217-3-0,
    #pgc-217-3-1,
    .panel-grid-cell {
        width: 50%;
        width: calc(50% - (0.5 * 100px))
    }
    #pgc-217-4-0,
    #pgc-217-4-1,
    #pgc-217-6-0,
    #pgc-217-6-1 {
        width: 50%;
        width: calc(50% - (0.5 * 30px))
    }
    #pl-217 .so-panel:last-child {
        margin-bottom: 0px
    }
    #pg-217-0.panel-no-style,
    #pg-217-0.panel-has-style > .panel-row-style,
    #pg-217-1.panel-no-style,
    #pg-217-1.panel-has-style > .panel-row-style,
    #pg-217-4.panel-no-style,
    #pg-217-4.panel-has-style > .panel-row-style {
        -webkit-align-items: flex-start;
        align-items: flex-start
    }
    @media (max-width: 780px) {
        #pg-217-0.panel-no-style,
        #pg-217-0.panel-has-style > .panel-row-style,
        #pg-217-1.panel-no-style,
        #pg-217-1.panel-has-style > .panel-row-style,
        #pg-217-2.panel-no-style,
        #pg-217-2.panel-has-style > .panel-row-style,
        #pg-217-3.panel-no-style,
        #pg-217-3.panel-has-style > .panel-row-style,
        #pg-217-4.panel-no-style,
        #pg-217-4.panel-has-style > .panel-row-style,
        #pg-217-5.panel-no-style,
        #pg-217-5.panel-has-style > .panel-row-style,
        #pg-217-6.panel-no-style,
        #pg-217-6.panel-has-style > .panel-row-style,
        #pg-217-7.panel-no-style,
        #pg-217-7.panel-has-style > .panel-row-style {
            -webkit-flex-direction: column;
            -ms-flex-direction: column;
            flex-direction: column
        }
        #pg-217-0 .panel-grid-cell,
        #pg-217-1 .panel-grid-cell,
        #pg-217-2 .panel-grid-cell,
        #pg-217-3 .panel-grid-cell,
        #pg-217-4 .panel-grid-cell,
        #pg-217-5 .panel-grid-cell,
        #pg-217-6 .panel-grid-cell,
        #pg-217-7 .panel-grid-cell {
            margin-right: 0
        }
        #pg-217-0 .panel-grid-cell,
        #pg-217-1 .panel-grid-cell,
        #pg-217-2 .panel-grid-cell,
        #pg-217-3 .panel-grid-cell,
        #pg-217-4 .panel-grid-cell,
        #pg-217-5 .panel-grid-cell,
        #pg-217-6 .panel-grid-cell,
        #pg-217-7 .panel-grid-cell {
            width: 100%
        }
        #pgc-217-3-0,
        #pgc-217-4-0,
        #pgc-217-6-0 {
            margin-bottom: 30px
        }
        #pl-217 .panel-grid-cell {
            padding: 0
        }
        #pl-217 .panel-grid .panel-grid-cell-empty {
            display: none
        }
        #pl-217 .panel-grid .panel-grid-cell-mobile-last {
            margin-bottom: 0px
        }
    }
</style>
<script>
    import api from '../api.js'
    import PopupSubscribe from './Subscribe'
    export
    default {
        data() {
            return {
                banner_pic: "",
                logo: "",
                amazon_buy_icon: "",
                items: [],
                left_comment: "",
                right_comment: "",
                summary:"",
            }
        },
        props: ["facebookIcon", "instagramIcon", "twitterIcon"],
        async mounted() {
            const res = await api.get('/api/index')
            if(res.data.code == 1) {
                this.banner_pic = this.$consts.serverPath + res.data.message.banner_pic;
                this.amazon_buy_icon = this.$consts.serverPath + res.data.message.amazon_buy_icon;
                this.summary = res.data.message.summary;
                this.group_items(res.data.message.items);
                this.group_tabloids(res.data.message.tabloids);
            }
        },
        methods: {
            group_items: function (rows) {
                    var c = [];
                    for (var k in rows) {
                        c[c.length] = rows[k]
                        if (k % 2 == 1 && k > 0) {
                            this.items[this.items.length] = c;
                            c = [];
                        } else if (k == rows.length - 1) {
                            this.items[this.items.length] = c;
                        }
                    }
                },
                group_tabloids: function (tabloids) {
                    for (var i = 0; i < tabloids.length; i++) {
                        if (tabloids[i]['position'] == 1) {
                            this.left_comment = tabloids[i]['content'];
                        } else {
                            this.right_comment = tabloids[i]['content'];
                        }
                    }
                },
        },
        components:{
            PopupSubscribe,
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Index.vue